/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Generating_StatusInputs */



/**
* | output |
* | --- |
* | "Generating Code... please wait." |
*
* @param {Offline_Activation_Generating_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_generating_status = /** @type {((inputs?: Offline_Activation_Generating_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Generating_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generation du code... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Code wird generiert... bitte warten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generazione del codice... attendere prego.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Генерация кода... пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generando código... por favor espere.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在生成代码……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コードを生成しています...お待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोड जनरेट हो रहा है... कृपया प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerando código... aguarde.")
	return /** @type {LocalizedString} */ ("Generating Code... please wait.")
});